module.exports = __webpack_public_path__ + "static/media/warning.48a1f986.svg";